import { createReducer } from '../../utilities';
import { scope, REFRESH_STATS } from '../../../actions/app/monitoring/statistics/registrations';
import {
    REQUEST_STATS_REGISTRATIONS,
    SUCCESS_FETCH_STATS_REGISTRATIONS,
    FAIL_FETCH_STATS_REGISTRATIONS
} from '../../../actions/entities/statistics/registrations';

const initialStatsRegistrationsState = {
    ids: [],
    total: null,
    info: {
        isFetching: false,
        lastPayload: null,
        needRefresh: true,
        updatedAt: null
    }
};

function requestRegistrations(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastPayload: action.payload,
            needRefresh: false,
            updatedAt: null
        }
    };
}

function successFetchRegistrations(state, action) {
    const { total, ids, payload, receivedAt } = action;
    return {
        ...state,
        ids,
        total,
        info: {
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            updatedAt: receivedAt
        }
    };
}

function failFetchRegistrations(state, action) {
    const { errors, payload } = action;
    return {
        ...state,
        info: {
            ...state.info,
            isFetching: false,
            lastPayload: payload,
            needRefresh: false,
            errors
        }
    };
}

function refreshRegistrations(state) {
    return {
        ...state,
        info: {
            ...state.info,
            needRefresh: true
        }
    };
}

export default createReducer(initialStatsRegistrationsState, {
    [REQUEST_STATS_REGISTRATIONS]: requestRegistrations,
    [SUCCESS_FETCH_STATS_REGISTRATIONS]: successFetchRegistrations,
    [FAIL_FETCH_STATS_REGISTRATIONS]: failFetchRegistrations,
    [REFRESH_STATS]: refreshRegistrations,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/registrations.js